import { Helmet } from "react-helmet";
import Navigation from "@/components/Navigation";
import FooterAlt from "@/components/FooterAlt";

const Team = () => {
  const teamMembers = [
    {
      name: "Arun Mohan",
      role: "Managing Partner",
      bio: "Serial entrepreneur with two successful exits and 20+ years building category-defining technology companies. Deep expertise in ecosystem-led growth strategies and hyperscaler partnerships across the GCC region, helping founders scale from seed to market leadership.",
      image: "/arun-mohan.jpg"
    },
    {
      name: "James Spearman",
      role: "Partner",
      bio: "Former Microsoft Cloud Specialist who has guided hundreds of enterprises through digital transformation. Brings invaluable hyperscaler relationships and technical expertise to help portfolio companies accelerate cloud adoption, reduce CAC, and unlock strategic growth partnerships.",
      image: "/james-spearman.jpg"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Meet the Team - AMX Ventures</title>
        <meta name="description" content="Meet the experienced team behind AMX Ventures, bringing decades of expertise in technology, cloud, and venture building." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-6 py-24">
          <div className="max-w-6xl mx-auto">
            {/* Page Header */}
            <div className="mb-16">
              <h1 className="text-5xl md:text-6xl font-bold text-accent mb-4">
                Meet the Team
              </h1>
              <div className="w-24 h-1 bg-accent"></div>
            </div>

            {/* Team Members Grid */}
            <div className="grid md:grid-cols-2 gap-16 md:gap-24">
              {teamMembers.map((member) => (
                <div key={member.name} className="flex flex-col items-center text-center">
                  {/* Photo */}
                  <div className="w-64 h-64 rounded-full bg-muted mb-8 overflow-hidden">
                    <img 
                      src={member.image} 
                      alt={`${member.name} - ${member.role}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  {/* Name */}
                  <h2 className="text-3xl md:text-4xl font-bold text-accent mb-2">
                    {member.name}
                  </h2>
                  
                  {/* Role */}
                  <p className="text-xl text-muted-foreground font-medium mb-6">
                    {member.role}
                  </p>
                  
                  {/* Bio */}
                  <p className="text-lg text-foreground/80 leading-relaxed max-w-md">
                    {member.bio}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </main>

        <FooterAlt />
      </div>
    </>
  );
};

export default Team;
